export default __webpack_public_path__ + "static/media/slide.17433cd3.gif";